import React from 'react';
import styled from 'styled-components';

import { Button } from '~ui-kit';

import cancelSVG from '~images/cancel.svg';
import { blue, green, lighterGrey } from '~theme';

const ModalWrapper = ({
  children,
  title,
  titleColor,
  backText,
  backOnClick,
  confirmText,
  confirmOnClick,
  confirmDisabled,
  close,
  headerIcon,
  headerLargeIcon,
  webshopMobile, // For webshop compatibility
}) => {
  return (
    <Wrapper>
      <Header>
        <HeaderTitle>
          {headerLargeIcon && <HeaderLargeIcon src={headerLargeIcon} />}
          {title && (
            <HeaderText color={titleColor}>
              {headerIcon && <HeaderIcon src={headerIcon} />} {title}
            </HeaderText>
          )}
        </HeaderTitle>
        {close && !webshopMobile && (
          <Close src={cancelSVG} onClick={() => close()} />
        )}
      </Header>

      {children}

      {(backOnClick || confirmOnClick) && !webshopMobile && (
        <Buttons>
          {backOnClick && (
            <Button
              w="48%"
              bgColor={lighterGrey}
              onClick={backOnClick} // () => setView('default')
            >
              {backText || 'Peruuta'}
            </Button>
          )}
          {confirmOnClick && (
            <Button
              w="48%"
              bgColor={confirmDisabled ? lighterGrey : green}
              onClick={confirmOnClick}
              disabled={confirmDisabled}
              // onClick={this.submit}
              // disabled={!this.props.items.filter(item => item.selected).length}
            >
              {confirmText || 'Ok'}
            </Button>
          )}
        </Buttons>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  // margin-bottom: 50px;
  padding: 50px;

  @media (max-width: 600px) {
    padding: 15px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
`;

const HeaderIcon = styled.img`
  margin-right: 5px;
  width: 37px;
`;

const HeaderLargeIcon = styled.img`
  height: 100px;
  margin-bottom: 24px;
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const HeaderText = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${props => (props.color ? props.color : blue)};
  line-height: 1.5;
`;

const Close = styled.img`
  align-self: flex-start;
  cursor: pointer;
  height: 34px;
  margin-bottom: 10px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default ModalWrapper;
